<template>
  <div class="card" v-bind="$attrs">
    <header v-if="$slots.header" class="card-header">
      <slot name="header" />
    </header>
    <div v-if="!noBody" class="card-body">
      <slot />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'BCard',
  inheritAttrs: false,
  props: {
    noBody: { type: Boolean, default: false }
  }
}
</script>
